export const SELECT_FEATURE = '[FEATURE] SELECT';
export const RESET_FEATURE_SELECTION = '[FEATURE] RESET_SELECTION';

export const MOUSEENTER_FEATURE = '[FEATURE] MOUSEENTER';
export const MOUSELEAVE_FEATURE = '[FEATURE] MOUSELEAVE';

export const LOAD_FEATURE_POPUP = '[FEATURE] LOAD_POPUP_DATA';
export const LOAD_FEATURE_POPUP_SUCCESS = '[FEATURE] LOAD_POPUP_DATA_SUCCESS';
export const LOAD_FEATURE_POPUP_FAILURE = '[FEATURE] LOAD_POPUP_DATA_FAILURE';

export const LOAD_FEATURE_GEOMETRY = '[FEATURE] LOAD_GEOMETRY_DATA';
export const LOAD_FEATURE_GEOMETRY_SUCCESS = '[FEATURE] LOAD_GEOMETRY_DATA_SUCCESS';
export const LOAD_FEATURE_GEOMETRY_FAILURE = '[FEATURE] LOAD_GEOMETRY_DATA_FAILURE';

export const selectFeature = (properties, teasersEndpoint, geometryEndpoint, coordinates) => ({
  type: SELECT_FEATURE,
  payload: {
    properties,
    teasersEndpoint,
    geometryEndpoint,
    coordinates,
  },
});

export const resetFeatureSelection = () => ({
  type: RESET_FEATURE_SELECTION,
});

export const loadFeaturePopup = (typoLink, teasersEndpoint) => ({
  type: LOAD_FEATURE_POPUP,
  payload: {
    typoLink,
    teasersEndpoint,
  },
});

export const loadFeaturePopupSuccess = html => ({
  type: LOAD_FEATURE_POPUP_SUCCESS,
  payload: html,
});

export const loadFeaturePopupFailure = error => ({
  type: LOAD_FEATURE_POPUP_FAILURE,
  payload: error,
});

export const loadFeatureGeometry = (id, geometryEndpoint) => ({
  type: LOAD_FEATURE_GEOMETRY,
  payload: {
    id,
    geometryEndpoint,
  },
});

export const loadFeatureGeometrySuccess = geoJson => ({
  type: LOAD_FEATURE_GEOMETRY_SUCCESS,
  payload: geoJson,
});

export const loadFeatureGeometryFailure = error => ({
  type: LOAD_FEATURE_GEOMETRY_FAILURE,
  payload: error,
});

export const mouseEnterFeature = properties => ({
  type: MOUSEENTER_FEATURE,
  payload: properties,
});

export const mouseLeaveFeature = () => ({
  type: MOUSELEAVE_FEATURE,
});
